import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { globalConst, onTrackYandexGoal } from 'modules/global';

import Banner from './banner';

const Main = () => (
  <div className="space-y-15">
    <Banner />

    <Link onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.auto_test_pro_banner)} href={globalConst.pageNames.PRO}>
      <div className="md:h-36.75 relative hidden  h-32 w-full sm:block">
        <Image fill src="/images/auto-test-banner.webp" alt="Olympic symbol" title="Olimpiada rasmi" />
      </div>
      <div className="h-30.75 relative w-full sm:hidden">
        <Image fill src="/images/auto-test-banner-mobile.webp" alt="Olympic symbol" title="Olimpiada rasmi" />
      </div>
    </Link>
  </div>
);

export default Main;
